import React, { useRef, useMemo } from "react";
import { useFrame } from "@react-three/fiber";
import * as THREE from "three";
import { envState } from "./env";

// Large animated harbor/Hudson water plane.
export default function Water() {
  const matRef = useRef();
  const geo = useMemo(() => new THREE.PlaneGeometry(5000, 5000, 32, 32), []);
  const base = useMemo(() => geo.attributes.position.array.slice(), [geo]);

  useFrame((state) => {
    const t = state.clock.elapsedTime;
    const pos = geo.attributes.position;
    for (let i = 0; i < pos.count; i++) {
      const x = base[i * 3];
      const y = base[i * 3 + 1];
      pos.array[i * 3 + 2] =
        Math.sin(x * 0.01 + t) * 0.6 + Math.cos(y * 0.013 + t * 0.8) * 0.5;
    }
    pos.needsUpdate = true;
    if (matRef.current) {
      const night = envState.night;
      matRef.current.color.setRGB(
        0.05 + (1 - night) * 0.05,
        0.16 + (1 - night) * 0.08,
        0.2 + (1 - night) * 0.06
      );
    }
  });

  return (
    <mesh geometry={geo} rotation={[-Math.PI / 2, 0, 0]} position={[0, -1.2, 0]} receiveShadow>
      <meshStandardMaterial
        ref={matRef}
        color="#123540"
        metalness={0.35}
        roughness={0.32}
      />
    </mesh>
  );
}
